import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ResetMapControlProps = {
  onClick: () => void;
};

export const ResetMapControl = ({ onClick }: ResetMapControlProps) => {
  return (
    <div className="maplibregl-ctrl-top-right" style={{ top: "70px" }}>
      <div className="maplibregl-ctrl maplibregl-ctrl-group">
        <button type="button" onClick={onClick} title="Reset map">
          <FontAwesomeIcon icon={faExpand} />
        </button>
      </div>
    </div>
  );
};
